import { chatIAState } from './ChatAiState';

export const useCurrentConversation = () => {
  return chatIAState((state) => ({
    currentConversation: state.currentConversation,
    setCurrentConversation: state.setCurrentConversation,
  }));
};
